import React, { useState } from "react";
import { Form, Input, Button, Flex, message } from "antd";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { LoadingOutlined } from "@ant-design/icons";
import { changePassword } from "../../services/ApiService";
import { decryptObject } from "../GlobalFunction";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [IsPassComplete, setIsPassComplete] = useState(false);
  const [form] = Form.useForm();
  const sessionData = decryptObject(sessionStorage.getItem("sessioninfo"));

  const onFinish = async (values) => {
    const hashCurrentPassword = CryptoJS.SHA256(values.oldpassword).toString();
    const hashNewPassword = CryptoJS.SHA256(values.newpassword).toString();
    let body = {
      oldPassword: hashCurrentPassword,
      newPassword: hashNewPassword,
      emailId: sessionData.emailId,
    };
    try {
      setLoader(true);

      const res = await changePassword(body);
      if (res.responseCode === 200) {
        await message.success(res.responseMessage);
        navigate("/login");
      } else {
        message.error(res.responseMessage);
      }
    } catch (error) {
      message.error("An error occurred. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  const validatePassword = (_, value) => {
    if (!value) {
      setIsPassComplete(false);
      return Promise.reject(new Error("Please enter a new password!"));
    }
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (!passwordPattern.test(value)) {
      setIsPassComplete(false);
      return Promise.reject(
        new Error(
          "Password must be at least 8 characters long, and include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 symbol."
        )
      );
    }
    setIsPassComplete(true);
    return Promise.resolve();
  };

  const handlePassword = () => {
    form
      .validateFields()
      .then(onFinish)
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  return (
    <>
      <h4 style={{ color: "#333B69", fontSize: "0.8rem", fontWeight: 500 }}>
        Change Password
      </h4>
      <Form
        form={form}
        name="login"
        initialValues={{ remember: true }}
        layout="vertical"
        style={{ marginTop: "1.3rem" }}
      >
        <Form.Item
          name="oldpassword"
          label={<span className="input-label">Enter Current Password</span>}
          rules={[
            { required: true, message: "Please Enter Current password!" },
          ]}
          colon={false}
        >
          <Input.Password
            placeholder="Enter Current Password"
            style={{ width: "25vw" }}
            className="input"
          />
        </Form.Item>

        <Form.Item
          name="newpassword"
          label={<span className="input-label"> New Password</span>}
          rules={[
            {
              required: true,
              message: "Please New password!",
            },
            { validator: validatePassword },
          ]}
          colon={false}
        >
          <Input.Password
            placeholder="Enter New Password"
            style={{ width: "25vw" }}
            className="input"
          />
        </Form.Item>
      </Form>
      <Flex justify="flex-start" className="login-btn">
        <Button
          type="primary"
          shape="round"
          disabled={!IsPassComplete || loader}
          onClick={handlePassword}
          style={{
            padding: "1.2rem",
            backgroundColor: "#4A3AFF",
          }}
        >
          Change Password
          {loader ? <LoadingOutlined style={{ color: "white" }} /> : <></>}
        </Button>
      </Flex>
    </>
  );
};

export default ChangePassword;
